import storage from 'app/blocks/common/storage';

const orcidChildMessageKey = 'orcidChildMessage';
const orcidParentMessageKeyPrefix = 'orcidParentMessage';
let orcidParentGuidKey = null;

const createParentMessageKey = () => `${orcidParentMessageKeyPrefix}_${Date.now()}}`;

export default {
    localStorageEventCallback: (e: { newValue: any; key: string }, callback: (newValue: any) => void) => {
        if (e.newValue && orcidParentGuidKey && orcidParentGuidKey === e.key) {
            callback(JSON.parse(e.newValue));
            storage.remove(orcidParentGuidKey);
        }
    },
    addOrcidStorageListener(callback) {
        const windowEvent = (e: StorageEvent) => this.localStorageEventCallback(e, callback);
        window.addEventListener('storage', windowEvent);
        if (orcidParentGuidKey) {
            this.localStorageEventCallback(
                {
                    newValue: storage.get(orcidParentGuidKey),
                    key: orcidParentGuidKey,
                },
                callback,
            );
        }
        return windowEvent;
    },
    removeOrcidStorageListener(windowEvent) {
        window.removeEventListener('storage', windowEvent);
    },
    setOrcIdParentMessage(message) {
        const parentStorageKey = storage.get(orcidChildMessageKey);
        storage.set(parentStorageKey, JSON.stringify(message));
        storage.remove(orcidChildMessageKey);
    },
    setOrcIdParentMessageKey() {
        orcidParentGuidKey = createParentMessageKey();
        storage.set(orcidChildMessageKey, orcidParentGuidKey);
    },
};
